import React from 'react';
import Svg from './Svg.jsx';
import './Canvas.scss';

export default function Canvas (props) {

    // render () {
        return (
            props.reticlesID.map(item => (
                <section
                    key={item.id}
                    id='canvas111'
                    className={item.class}
                    style={{ cursor: props.activeShapeButton.name === 'move' ? 'default' : 'crosshair', position: "relative"}}
                >
                    <Svg
                        svgID = {item.id}
                        rootId={`canvas-root-${item.id}`}
                        alignTop={props.alignTop}
                        instruments={props.instruments}
                        svgUpdateData={props.svgUpdateData}
                        getSelectedShapes={props.getSelectedShapes}
                        setGroupedShapes={props.setGroupedShapes}
                        strokeWidth={props.strokeWidth}
                        strokeColor={props.strokeColor}
                        align={props.align}
                        getCanvasShapesData={props.getCanvasShapesData}
                        getMarkersData={props.getMarkersData}
                        getNewMarkerCoords={props.getNewMarkerCoords}
                        getCurrentID={props.getCurrentID}
                        getDeletedIndex={props.getDeletedIndex}
                        getGroupedData={props.getGroupedData}
                        getSelectedShape={props.getSelectedShape}
                        getSelectedShapeWidth={props.getSelectedShapeWidth}
                        onSelectChangeMove={props.onSelectChangeMove}
                        focusedInput={props.focusedInput}
                        duplicateDeactivate={props.duplicateDeactivate}
                        undoRedoDeactivate={props.undoRedoDeactivate}
                        clearDeactivate={props.clearDeactivate}
                        activeShapeButton={props.activeShapeButton}
                        getSelectedShapeStrokeColor={props.getSelectedShapeStrokeColor}
                        getClearedData2Export={props.getClearedData2Export}
                        isExport={props.isExport}
                        getLineGridLength={props.getLineGridLength}
                        fillShapePrevOpacity={props.fillShapePrevOpacity}
                        fillShapePrevColor={props.fillShapePrevColor}
                        fillColor={props.fillColor}
                        opacity={props.opacity}
                        reticlesID={props.reticlesID}
                        activeTabId={props.activeTabId}
                        activeTab={props.activeTab}
                        gridDisabled={props.gridDisabled}
                        setCleanedSvg={props.setCleanedSvg}
                        disableEditParam={props.disableEditParam}
                        disableAxisSwitch={props.disableAxisSwitch}
                        firstSave={props.firstSave}
                        disableFirstSave={props.disableFirstSave}
                        disablefpSwitcher={props.disablefpSwitcher}
                        fpSwitchOff={props.fpSwitchOff}
                        switchOffisFillColorSet={props.switchOffisFillColorSet}
                        switchOffisStrokeColorSet={props.switchOffisStrokeColorSet}
                        layerMoveSwitcher={props.layerMoveSwitcher}
                        rotateSwitcher={props.rotateSwitcher}
                        getSelectedShapesType={props.getSelectedShapesType}
                        isShapeDelete={props.isShapeDelete}
                        toggleDeleteShape={props.toggleDeleteShape}
                        setStrokeType={props.setStrokeType}
                        strokeDasharray={props.strokeDasharray}
                        isStrokeTypeChanged={props.isStrokeTypeChanged}
                        resetStrokeTypeChanged={props.resetStrokeTypeChanged}
                        importReticle={props.importReticle}
                        clearImportData={props.clearImportData}
                        appVersion={props.appVersion}
                        setActiveShapeButton={props.setActiveShapeButton}
                    />
                </section>)
            )
        )
    } 
// }

// export default Canvas;
